const liftTypeLength = {
  'Cordless': {
    minWidth: 16,
    maxWidth: 72,
    minLength: 24,
    maxLength: 84
  },
  'Corded': {
    minWidth: 20,
    maxWidth: 84,
    minLength: 20,
    maxLength: 96
  },
  'Motorized': {
    minWidth: 23,
    maxWidth: 96,
    minLength: 18,
    maxLength: 120
  },
  'Motorized(Cordless)': {
    minWidth: 36,
    maxWidth: 96,
    minLength: 24,
    maxLength: 137
  },
  'Cordless(Motorized)': {
    minWidth: 36,
    maxWidth: 96,
    minLength: 24,
    maxLength: 137
  }
};
var collText = '', isSunShade = false, isInside = true, resultWidth = 0, resultWidthEighths = 0, resultLength = 0, resultLengthEighths = 0, showWidth = 0, showLength = 0;
$('.popupContainer.measurement').on('click', function () {
  setThemeGuideOpen(this, false);
})

$('.popupContainer.measurement .popupBox .popupTitle svg').on('click', function () {
  $(this).closest('.popupContainer').click();
})

$('.popupContainer.measurement .popupBox').on('click', function (event) {
  event.stopPropagation();
})

$('.popupContainer.measurement .popupBox .popupBody .step > div').on('click', function () {
  if ($(this).attr('disabled') == 'disabled') {
    return;
  }
  var currentIndex = $(this).index();
  stepChange(false);

  if (currentIndex + 1 >= $('.popupContainer.measurement .popupBox .popupBody .step > div').length) {
    var type = false;
    $.each($('.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox'), function(i, item) {
      const index = $(item).index();
      if (checkStep(index)) {
        type = true;
        currentIndex = index;
        return false;
      }
    });
    if (!type) {
      resultChange();
    }
  }

  scrollChangeNum({
    ele: '.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList',
    direction: 'horizontal',
    num: currentIndex
  });

  // 底部按钮展示
  $('.btnList .btns').css('display', currentIndex + 1 < $('.popupContainer.measurement .popupBox .popupBody .step > div').length ? 'none' : 'flex');
  $('.btnList > .btn').css('display', currentIndex + 1 < $('.popupContainer.measurement .popupBox .popupBody .step > div').length ? 'flex' : 'none');
})

$('.popupContainer.measurement .popupBox .popupBody .stepContainer .nextStep').on('click', function () {
  const type = checkStep($('.popupContainer.measurement .popupBox .popupBody .step > div.active').index());
  if (!type) {
    $(this).attr('click-data', `SizeGuideStep${type}`);
    stepChange();
  }
})

function checkStep(index) {
  var currentStep = $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox').eq(index);
  var inputType = false, optionType = false;

  if (currentStep.find('.option:not([col="1"])').length > 0) {
    optionType = currentStep.find('.optionItem.active').length == 0;
  }

  $.each(currentStep.find('input[required]'), function (i, item) {
    $(item).css('border-color', $(item).val().length == 0 || $(item).val() == 0 ? '#b11500' : '#1F1F1F');
    if ($(item).val().length == 0 || $(item).val() == 0) {
      inputType = true;
    }
  });

  currentStep.find('.option').css('border-color', optionType ? '#b11500' : 'transparent');

  return inputType || optionType;
}

$('.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox .optionList .inputList .selectBox .selectName').on('click', function () {
  var type = $(this).hasClass('active');
  if (type) {
    $(this).removeClass('active');
  } else {
    $(this).addClass('active');
  }
})

$('.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox .optionList .inputList .selectBox .selectList > div').on('click', function () {
  var $selectBox = $(this).closest('.selectBox');
  var $input = $(this).find('input');
  $input.prop('checked', true);
  $selectBox.find('.selectName').text($input.val()).removeClass('active');
})

function stepChange (type = true) {
  var current = $('.popupContainer.measurement .popupBox .popupBody .step > div.active');
  var currentStep = $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox').eq(current.index());

  var isOutdoorShade = $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="collections"] .optionItem.active').attr('data-value') == 'Outdoor';
  var isRoman = $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="collections"] .optionItem.active').attr('data-value') == 'Roman';

  $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="lift"] .optionItem[data-value="Motorized(Cordless)"]').css('display', isOutdoorShade || isRoman ? 'none' : 'flex');
  if (isOutdoorShade || isRoman) {
    $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="lift"] .optionItem[data-value="Motorized(Cordless)"]').removeClass('active');
  }

  // true: Inside; false: Outside;
  if ($('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="mount"] .optionItem.active').length > 0) {
    isInside = $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="mount"] .optionItem.active').attr('data-value') == 'true';
    if (isInside) {
      $('.popupContainer.measurement .popupBox input[data-type="widthA"]').val(0);
      $('.popupContainer.measurement .popupBox input[data-type="widthB"]').val(0);
    }
    $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="width"] .first .msg span').css('display', isInside ? 'flex' : 'none');
    $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="length"] .optionItem[data-value="true"]').css('display', isInside ? 'flex' : 'none');
    $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="length"] .optionItem[data-value="false"]').css('display', !isInside ? 'flex' : 'none');
    $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="length"] .inputList > .msg').text(isInside ? 'Measure the left, center and right portion of the inside frame and use the longest height measurement.' : `Measure ${Math.floor(4 * window.Shopify.currency.lengthRate)}-${Math.floor(8 * window.Shopify.currency.lengthRate)}${window.Shopify.currency.lengthUnit} from above the window, down to where you want the shade to sit.`);

    if (!isInside && currentStep.find('.first').length > 0 && currentStep.find('.first').css('display') != 'none') {
      // Outside
      currentStep.find('.first').css('display', 'none');
      currentStep.find('.branch').css('display', 'flex');
      return;
    }
  }
  $('.inputBox[data-type="Eighths"]').css('display', window.Shopify.currency.icon == '$' ? 'flex' : 'none');
  if (type) {
    current.next().removeAttr('disabled').click();
    $('.nextStep').attr('click-data', `SizeGuideStep${current.next().index() + 1}`);
  }
}

function scrollChangeNum (list = {
  ele, direction: 'horizontal', num: 1
}) {
  // horizontal: 水平; vertical: 垂直
  // 元素可活动范围
  var eleScroll = list.direction == 'vertical' ? $(list.ele)[0].scrollHeight : $(list.ele)[0].scrollWidth;
  // 第一个子元素大小
  var elechilrenSize = list.direction == 'vertical' ? $(list.ele).find('>*:first-of-type').outerHeight() : $(list.ele).find('>*:first-of-type').outerWidth();
  // 子元素间距
  var elechilrenSpace = (eleScroll - elechilrenSize * $(list.ele).find('>*').length) / ($(list.ele).find('>*').length - 1);

  var pre = (elechilrenSize + elechilrenSpace) * list.num;

  if (list.direction == 'vertical') {
    $(list.ele).animate({
      scrollTop: pre
    }, {
      duration: 150,
    });
  } else {
    $(list.ele).animate({
      scrollLeft: pre
    }, {
      duration: 150,
    });
  }

  $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox').eq(list.num).find('.first').css('display', 'flex');
  $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox').eq(list.num).find('.branch').css('display', 'none');

  $('.popupContainer.measurement .popupBox .popupBody .step > div').removeClass('active');
  $('.popupContainer.measurement .popupBox .popupBody .step > div').eq(list.num).removeAttr('disabled').addClass('active');
}

$('.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox .optionList .inputList input').on('change', function () {
  var text = Math.round(Math.abs($(this).val()));
  $(this).val(text);
})

$('.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox .optionList .inputList input').on('keydown', function () {
  if (event.which == 13) {
    $('.popupContainer.measurement .popupBox .popupBody .stepContainer .nextStep').click();
  }
})

$('.popupContainer.measurement .popupBox .btns .btn').on('click', function () {
  var type = $(this).attr('type');

  if (type == 'white') {
    // reset
    $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox .optionItem').removeClass('active');
    $('.popupContainer.measurement .popupBox input').val('');
    $('.popupContainer.measurement .popupBox .popupBody .step > div:not(:first-of-type)').removeClass('active').attr('disabled', true);
    $('.popupContainer.measurement .popupBox .popupBody .step > div:first-of-type').click();
  }

  if (type == 'black' && $('.outChangeMsg').css('display') == 'none') {
    // shop now
    window.open($(this).attr('data-href'), '_blank');
  }
})

$('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox .option .optionItem .itemBox').on('click', function () {
  $(this).closest('.option').css('border-color', 'transparent');
  $(this).closest('.option').find('.optionItem').removeClass('active');
  $(this).parent().addClass('active');

  // true: Inside; false: Outside;
  isInside = $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="mount"] .optionItem.active').attr('data-value') == 'true';
  if (isInside) {
    $('.popupContainer.measurement .popupBox input[data-type="widthA"]').val(0);
    $('.popupContainer.measurement .popupBox input[data-type="widthB"]').val(0);
  }
  $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="width"] .first .msg span').css('display', isInside ? 'flex' : 'none');
  $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="length"] .optionItem[data-value="true"]').css('display', isInside ? 'flex' : 'none');
  $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="length"] .optionItem[data-value="false"]').css('display', !isInside ? 'flex' : 'none');
  $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="length"] .inputList > .msg').text(isInside ? 'Measure the left, center and right portion of the inside frame and use the longest height measurement.' : `Measure ${Math.floor(4 * window.Shopify.currency.lengthRate)}-${Math.floor(8 * window.Shopify.currency.lengthRate)}${window.Shopify.currency.lengthUnit} from above the window, down to where you want the shade to sit.`);
})

function stepcollChange() {
  var collActive = $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="collections"] .optionItem.active');
  var collections = collActive.attr('data-value');
  var lift = $('.stepBox[data-type="lift"] .optionItem.active').attr('data-value');
  var href = collActive.attr('data-href');
  collText = collActive.text().trim();

  if (collections == 'Roman' && lift == 'Corded') {
    collText = 'Yarn Sheer Relaxed Custom Roman Shade';
    href = '/products/yarn-sheer-relaxed-custom-roman-shade';
  }
  if (lift == 'Motorized(Cordless)') {
    collText = 'Motorized Woven Shade';
    href = '/collections/motorized-motorized-woven-shade';
  }

  $('.popupContainer.measurement .popupBox .btns .btn[type="black"]').attr('data-href', `${window.Shopify.routes.root.slice(0, -1)}${href}`);
}

function resultChange () {
  stepcollChange();
  var windowWidth = 0, windowLength = 0;
  var lift = $('.stepBox[data-type="lift"] .optionItem.active').attr('data-value');
  var width = parseInt($('.popupContainer.measurement .popupBox input[data-type="width"]').val() || 0),
    widthEighths = $('.popupContainer.measurement .popupBox input[name="width_Eighths"]:checked').val() || '0"',
    widthA = parseInt($('.popupContainer.measurement .popupBox input[data-type="widthA"]').val() || 0),
    widthB = parseInt($('.popupContainer.measurement .popupBox input[data-type="widthB"]').val() || 0);
  var height = parseInt($('.popupContainer.measurement .popupBox input[data-type="height"]').val() || 0),
    heightEighths = $('.popupContainer.measurement .popupBox input[name="height_Eighths"]:checked').val() || '0"';

  windowWidth = width + widthA + widthB;
  windowLength = height;

  resultWidth = showWidth = windowWidth;
  resultLength = showLength = windowLength;
  resultWidthEighths = widthEighths.split('"')[0];
  resultLengthEighths = heightEighths.split('"')[0];

  if (isInside) {
    if (window.Shopify.currency.icon == '$') {
      var decimalResult = 0;
      if (resultWidthEighths != '0') {
        decimalResult = fractionToDecimal(resultWidthEighths);
      }

      var sizewidth = resultWidth + decimalResult - 0.5;
      resultWidth = Math.floor(sizewidth);
      resultWidthEighths = `${sizewidth - resultWidth != 0 ? decimalToFraction(sizewidth - resultWidth) : 0}`;
    } else if (window.Shopify.routes.root != '/') {
      resultWidth -= 1.5;
    }
  }

  showWidth = resultWidth;
  showLength = resultLength;

  if (window.Shopify.country != "US") {
    resultWidth = Math.ceil(resultWidth / window.Shopify.currency.lengthRate);
    resultLength = Math.ceil(resultLength / window.Shopify.currency.lengthRate);
    showWidth = Math.ceil(resultWidth * window.Shopify.currency.lengthRate);
    showLength = Math.ceil(resultLength * window.Shopify.currency.lengthRate);
  }

  var widthType = false, lengthType = false;

  if (!isSunShade) {
    // 获取当前选中的升降类型配置
    const liftTypeList = liftTypeLength[lift];
    // 创建深拷贝（避免修改原始配置）
    const liftItem = {
      minWidth: liftTypeList.minWidth,
      maxWidth: liftTypeList.maxWidth,
      minLength: liftTypeList.minLength,
      maxLength: liftTypeList.maxLength
    };
    // 非美国地区进行单位转换
    if (window.Shopify.country !== "US") {
      const rate = window.Shopify.currency.lengthRate;
      liftItem.minWidth = Math.ceil(liftTypeList.minWidth * rate);
      liftItem.minLength = Math.ceil(liftTypeList.minLength * rate);
      liftItem.maxWidth = Math.ceil(liftTypeList.maxWidth * rate);
      liftItem.maxLength = Math.ceil(liftTypeList.maxLength * rate);
    }
    widthType = showWidth >= liftItem.minWidth && showWidth <= liftItem.maxWidth;
    lengthType = showLength >= liftItem.minLength && showLength <= liftItem.maxLength;
  }
  
  var arr = {
    "collections": collText,
    "mount": isInside ? 'Inside' : 'Outside',
    "lift": lift == 'Motorized(Cordless)' ? 'motorized' : lift,
    "width": parseInt($('.popupContainer.measurement .popupBox input[data-type="width"]').val() || 0),
    "widthEighths": $('.popupContainer.measurement .popupBox input[name="width_Eighths"]:checked').val() || '0"',
    "widthA": parseInt($('.popupContainer.measurement .popupBox input[data-type="widthA"]').val() || 0),
    "widthB": parseInt($('.popupContainer.measurement .popupBox input[data-type="widthB"]').val() || 0),
    "height": parseInt($('.popupContainer.measurement .popupBox input[data-type="height"]').val() || 0),
    "lengthEighths": $('.popupContainer.measurement .popupBox input[name="height_Eighths"]:checked').val() || '0"',
  };
  localStorage.setItem("measurementGuide", JSON.stringify(arr));

  $('.popupContainer .popupBox .popupBody .stepContainer .btnList .btns .btn[type=black]').attr('disabled', !widthType || !lengthType);
  $('.resultTitle').html(`Based on the information provided, our recommended order details for ${collText} are as follows:`);
  $('.outChangeMsg').css('display', !widthType || !lengthType ? 'block' : 'none');
  $('.resultSize').html(`<p>${isInside ? 'Inside' : 'Outside'}MOUNT</p><p><span>${showWidth} ${resultWidthEighths != '0' ? resultWidthEighths : ''}${window.Shopify.currency.lengthUnit}</span>WIDTH</p><p><span>${showLength} ${resultLengthEighths != '0' ? resultLengthEighths : ''}${window.Shopify.currency.lengthUnit}</span>LENGTH</p>`);
}
